import { store } from '../store';

class Store {
  /**
   * set results
   * @param name
   * @param value
   */
  setResultsStore(name, value) {
    store.commit('store/setResultsStore', {
      name: name,
      value: value,
    });
  }

  setResultsStores(values) {
    if (typeof values === 'string') {
      values = JSON.parse(values);
    }
    if (typeof values === 'object') {
      for (const key in values) {
        this.setResultsStore(key, values[key]);
      }
    }
  }

  /**
   * set module stores
   * @param values
   */
  setStores(values) {
    if (typeof values === 'string') {
      values = JSON.parse(values);
    }

    if (typeof values === 'object') {
      for (const key in values) {
        this.setStore(key, values[key]);
      }
    }
  }

  setStore(name, value) {
    store.commit('store/setStore', { name, value });
  }

  /** commit * */
  commit(name, payload) {
    store.commit(name, payload);
  }

  /**
   * getters
   */
  getStoreContext() {
    return store;
  }
}

export default Store;
